module.exports = __webpack_public_path__ + "static/img/6.321f04e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/6.png
// module id = eEO5
// module chunks = 0